var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg3Ingos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94,
    r: 93.5,
    fill: "#FF7C22",
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4062 94.3911C50.4062 91.5261 52.7292 89.2031 55.5942 89.2031C58.4592 89.2031 60.7822 91.5261 60.7822 94.3911C60.7822 97.2561 58.4592 99.5791 55.5942 99.5791C52.7292 99.5791 50.4062 97.2561 50.4062 94.3911Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.344 94.3911C103.344 91.5261 105.667 89.2031 108.532 89.2031C111.397 89.2031 113.72 91.5261 113.72 94.3911C113.72 97.2561 111.397 99.5791 108.532 99.5791C105.666 99.5791 103.344 97.2561 103.344 94.3911Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2247 122.741L50.4037 108.062L42.5827 122.741C41.3117 125.084 40.6797 126.341 40.6797 128.5C40.6797 133.87 45.0327 138.224 50.4027 138.224C55.7727 138.224 60.1257 133.87 60.1257 128.5C60.1277 126.341 59.6277 125.432 58.2247 122.741Z",
    stroke: "white",
    strokeWidth: 4.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4922 117.88C70.3042 114.805 76.0222 113.023 82.1562 113.023C89.0472 113.023 95.4142 115.273 100.56 119.077",
    stroke: "white",
    strokeWidth: 4.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3Ingos);
export default __webpack_public_path__ + "static/media/svg-3-ingos.b06443004dde24d5fdd9ded36e486671.svg";
export { ForwardRef as ReactComponent };